// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'Oxygen';
    font-style: normal;
    font-weight: 400;
    src: local('Oxygen'), local('Oxygen-Regular'), url(https://fonts.gstatic.com/s/oxygen/v5/LC4u_jU27qpsdszDEgeU_3-_kf6ByYO6CLYdB4HQE-Y.woff2) format('woff2');
    unicode-range: U+30-39;
}


.content_room_list {

    font-family: Poppins, sans-serif;
    
    display: flex;
    flex-direction: column;
    opacity: 1;
    margin: 0;
    margin-top:50px;
    overflow: auto;

    min-height: 100svh;
}
@keyframes gradient {
    0% {
        background-position: 0% 0%;
    }
    50% {
        background-position: 100% 100%;
    }
    100% {
        background-position: 0% 0%;
    }
}
.fade {
    opacity: 0;
    animation: fade-in 0.5s ease-in-out forwards;
}

@keyframes fade-in {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}
.container-gold-room h2{
    font-family: Montserrat, sans-serif;
    font-weight: 900;
    line-height: 1;
    color:white;
}

.search-wrapper.active {}

.search-wrapper .input-holder {
    height: 70px;
    width:70px;
    overflow: hidden;
    border-radius:6px;
    position: relative;
    transition: all 0.3s ease-in-out;
}
.search-wrapper.active .input-holder {
    width:300px;
    border-radius: 50px;
    background: #070c1b;
    transition: all .5s cubic-bezier(0.000, 0.105, 0.035, 1.570);
}
.balanceRoom span{
    color: greenyellow !important;
    font-family: "Montserrat",sans-serif;
}
.search-wrapper .input-holder .search-input {
    width:100%;
    height: 50px;
    padding:0px 70px 0 20px;
    opacity: 0;
    position: absolute;
    top:0px;
    left:0px;
    background: transparent;
    box-sizing: border-box;
    border:none;
    outline:none;
    font-family:"Open Sans", Arial, Verdana;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    color:#FFF;
    transform: translate(0, 60px);
    transition: all .3s cubic-bezier(0.000, 0.105, 0.035, 1.570);
    transition-delay: 0.3s;
}
.search-wrapper.active .input-holder .search-input {
    opacity: 1;
    transform: translate(0, 10px);
}
.search-wrapper .input-holder .search-icon {
    width:70px;
    height:70px;
    border:none;
    border-radius:6px;
    background: #FFF;
    padding:0px;
    outline:none;
    position: relative;
    z-index: 2;
    float:right;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
}
.search-wrapper.active .input-holder .search-icon {
    width: 50px;
    height:50px;
    margin: 10px;
    border-radius: 30px;
}
.search-wrapper .input-holder .search-icon span {
    width:22px;
    height:22px;
    display: inline-block;
    vertical-align: middle;
    position:relative;
    transform: rotate(45deg);
    transition: all .4s cubic-bezier(0.650, -0.600, 0.240, 1.650);
}
.search-wrapper.active .input-holder .search-icon span {
    transform: rotate(-45deg);
}
.search-wrapper .input-holder .search-icon span::before, .search-wrapper .input-holder .search-icon span::after {
    position: absolute;
    content:'';
}
.search-wrapper .input-holder .search-icon span::before {
    width: 4px;
    height: 11px;
    left: 9px;
    top: 18px;
    border-radius: 2px;
    background: #FE5F55;
}
.search-wrapper .input-holder .search-icon span::after {
    width: 14px;
    height: 14px;
    left: 0px;
    top: 0px;
    border-radius: 16px;
    border: 4px solid #FE5F55;
}
.search-wrapper .close {
    position: absolute;
    z-index: 1;
    top:24px;
    right:20px;
    width:25px;
    height:25px;
    cursor: pointer;
    transform: rotate(-180deg);
    transition: all .3s cubic-bezier(0.285, -0.450, 0.935, 0.110);
    transition-delay: 0.2s;
}
.search-wrapper.active .close {
    right:-50px;
    transform: rotate(45deg);
    transition: all .6s cubic-bezier(0.000, 0.105, 0.035, 1.570);
    transition-delay: 0.5s;
}
.search-wrapper .close::before, .search-wrapper .close::after {
    position:absolute;
    content:'';
    background: #FE5F55;
    border-radius: 2px;
}
.search-wrapper .close::before {
    width: 5px;
    height: 25px;
    left: 10px;
    top: 0px;
}
.search-wrapper .close::after {
    width: 25px;
    height: 5px;
    left: 0px;
    top: 10px;
}
.pagination button {
    font-size: 20px;
    padding: 5px 10px;
    margin-right: 10px;
    font-family: "Oxygen";
    background-image: linear-gradient(to right, #7474BF 0%, #348AC7 51%, #7474BF 100%);
    transition: 0.5s;
    background-size: 200% auto;
    color: white;
    border-radius: 5px;
}

.pagination button:hover {
    background-position: right center; /* change the direction of the change here */
    color: #fff;
    text-decoration: none;
}


.pagination{
    margin-top: 15px;
}
.pagination .page{
    margin: 10px;
}
.content_table table {
    transition: opacity 0.5s ease-in-out;
}
.sidebar {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
}





.sidebar button {
    color: white;
    background-image: linear-gradient(to right, #24C6DC 0%, #514A9D  51%, #24C6DC  100%);
    transition: 0.5s;
    background-size: 200% auto;


    border-radius: 50px;
    margin: 10px;
    font-size: 20px;
    background-color: #ba00ff;
    min-width: 200px;
}
.sidebar button:hover {
    background-position: right center; /* change the direction of the change here */
    color: #fff;
    text-decoration: none;
}
@media screen and (max-width: 519px) {
    .content_table table {
        max-width: 1000px;
        font-size: 12px;
    }

    th,
    td {
        padding: 8px;
    }
}
@media  screen and (max-width: 380px){
    .content_table h1{
        font-size: 25px;
    }
}
@media screen and (max-width: 673px) {
    .sidebar {
        justify-content: center;
        flex-direction: column;
        align-items: center;
    }
}

.search_box {
    display: flex;
    justify-content: center;
    margin-top: 10px;

}
.search_box.room{
    margin-bottom: 10px;
}
.second_list{
    display: flex;
    justify-content: center;
}
.second_list .ico{

    margin-left: 20px;
    margin-top: 35px;
}
.fa-refresh{
    font-size: 30px;
    color: #24C6DC;

}

.input-holder{
    display: flex;
    justify-content: center;
    align-items: center;
}
.container-gold-room{
    max-height:150px;
    display: flex;
    justify-content: center;
    margin-bottom: 20px;

}

.content-gold-room{

    border-radius: 15px;
    display: flex;
    justify-content: center;
    padding: 10px;
    background: linear-gradient(-45deg, #FFD700, #FFA500, #FFD700, #FFA500);
    background-size: 200% 200%;
    animation: shine 2s linear infinite;
}
.content-bonus-room{
    width: 257px;
    border-radius: 15px;
    display: flex;
    justify-content: center;
    padding: 10px;
    background: linear-gradient(-45deg, #4CAF50, #2E8B57, #4CAF50, #2E8B57);
    background-size: 200% 200%;
    animation: shine 2s linear infinite;
}
.content-gold-room h2{
    text-align: center !important;
}
.content-gold-room p{
    text-align: center !important;
    font-weight: 700;
    font-family: 'Poppins', sans-serif;
    color: #4f830b;
    font-size: 40px;
}
.spans p{
    text-align: center;
    font-family: Montserrat,sans-serif;
}
@keyframes shine {
    0% {
        background-position: 200% 0;
    }
    100% {
        background-position: -200% 0;
    }
}
.content_table {
    display: flex;
    justify-content: center;
    align-items: center;
}

.content_table table {
    border-collapse: collapse;
    border-radius: 10px;
    max-width: 1000px;
    background-color: #161c32; /* Темный цвет таблицы */
    color: #FFF;
    font-family: Arial, sans-serif;
}

.content_table th, td {
    padding: 16px;
    text-align: center;
    border-bottom: 1px solid #2C3845;
    font-family: "Montserrat",sans-serif;

}


/*tr:hover {*/
/*    background-color: #574F7D;*/
/*}*/

.buttonConnect {
    padding: 5px 10px;
    border-radius: 5px;
    /*background-color: #46bebd;*/
    color: white;
    box-sizing: border-box;

    background: linear-gradient(90deg, #03a9f4, #f441a5, #ffeb3b, #03a9f4);
    background-size: 400%;
    border: none;
    cursor: pointer;
    font-family: Arial, sans-serif;
}
.info-gold-i{
    color:#5C62EC;
    font-size: 30px;
}
/*.buttonConnectGold{*/
/*    text-align: center;*/
/*    margin-top: 10px;*/
/*    padding: 5px 10px;*/
/*    border-radius: 10px;*/
/*    font-size: 20px;*/
/*    !*background-color: #46bebd;*!*/
/*    color: white;*/
/*    box-sizing: border-box;*/
/*    height: 50px;*/
/*    width: 200px;*/

/*    background: linear-gradient(90deg, #03a9f4, #f441a5, #03a9f4);*/
/*    background-size: 400%;*/
/*    border: none;*/
/*    cursor: pointer;*/
/*    font-family: Arial, sans-serif;*/
/*    animation: shine 8s linear infinite;*/

/*}*/

@keyframes animate {
    0% {
        background-position: 0%;
    }
    100% {
        background-position: 400%;
    }
}

.buttonConnect:hover {
    animation: animate 8s linear infinite;
}
/*.buttonConnectGold:hover{*/
/*    animation: animate 8s linear infinite;*/

/*}*/
/*.buttonConnect:before {*/
/*    content: "";*/
/*    position: absolute;*/
/*    top: -5px;*/
/*    right: -5px;*/
/*    bottom: -5px;*/
/*    left: -5px;*/
/*    z-index: -1;*/
/*    background: linear-gradient(90deg, #03a9f4, #f441a5, #ffeb3b, #03a9f4);*/
/*    background-size: 400%;*/
/*    border-radius: 40px;*/
/*    opacity: 0;*/
/*    transition: .5s;*/
/*}*/
.pulse-circle {
    display: inline-block;
    width: 12px;
    height: 12px;
    margin-left: 6px;
    border-radius: 50%;
    background-color: #4CAF50;
    animation: pulse 2s ease-in-out infinite;
}
.box-gold-room form {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 500px;
    padding: 50px 35px;
    box-sizing: border-box;
    background: linear-gradient(0deg, #000, #272727);
    border-radius: 10px;
}


.box-gold-room form::before,
.box-gold-room form::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 10px; /* Скругляем края псевдоэлементов */
    background: linear-gradient(0deg, #000, #272727);
}

.box-gold-room form::before {
    left: 0;
    top: 0;
    box-shadow: 0 0 30px rgba(255, 215, 0, 0.9); /* Золотистая тень */
}

.box-gold-room form::after {
    right: 0;
    bottom: 0;
    box-shadow: 0 0 30px rgba(255, 215, 0, 0.9); /* Золотистая тень */
}
.box-gold-room form p{
    font-weight: 700;
    text-align: center;

}

.pulse-circle.red{
    background-color: red;
}
.pagination{
    display: flex;
    justify-content: center;
    align-items: center;
}
@keyframes pulse {
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.2);
    }
    100% {
        transform: scale(1);
    }
}
/*.modal-container {*/
/*    position: fixed;*/
/*    top: 0;*/
/*    left: 0;*/
/*    width: 100%;*/
/*    height: 100%;*/
/*    z-index: 100;*/
/*    background: rgba(0, 0, 0, 0.5); !* Приглушение заднего фона *!*/
/*    display: flex;*/
/*    align-items: center;*/
/*    justify-content: center;*/
/*    animation: fadeIn 0.3s ease-in;*/
/*}*/

/*.modal {*/
/*    display: flex;*/

/*    justify-content: center;*/
/*    align-items: center;*/
/*    background: #fff;*/
/*    padding: 20px;*/
/*    border-radius: 5px;*/
/*    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);*/
/*    animation: slideIn 0.3s ease-in;*/
/*}*/
.modal-container{

    z-index: 100;
    opacity: 1!important;
    /*height: 100vh;*/
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@keyframes slideIn {
    from {
        transform: translateX(-50px);
    }
    to {
        transform: translateX(0);
    }
}
.real-cash-button {
    background: #8BC34A !important;
    margin-right: 10px !important;
    border-radius: 12px !important;
    border: 0 !important;
    box-sizing: border-box !important;
    color: #eee !important;
    cursor: pointer !important;
    font-size: 15px !important;
    margin-top: 38px !important;
    text-align: center !important;
    width: 100% !important;
}
.bonus-cash-button{
    background: #5C62EC !important;
    border-radius: 12px !important;
    border: 0 !important;
    box-sizing: border-box !important;
    color: #eee !important;
    cursor: pointer !important;
    font-size: 15px !important;

    margin-top: 38px!important;
    text-align: center!important;
    width: 100%!important;
}
.enter_model_h2{
    margin-bottom: 0!important;
}
.tooltip-container {

    position: relative;
    display: inline-block;
    cursor: pointer;
    padding: 10px;
    z-index:100;
}

.tooltip-text {
    position: absolute;
    background-color: black;
    color: #fff;
    padding: 8px;
    border-radius: 15px;
    font-family: monospace , sans-serif;
    font-size: 16px;
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
    top: -300%;


    pointer-events: none;
}
.tooltip-text.gold{
    top:-260%;
    left:-10%;
}
.tooltip-text.bonus{
    top:-320%;
    left:-20%;
}


.tooltip-container:hover .tooltip-text {
    opacity: 1;
}


.buttonConnectGold {
    text-decoration: none;
    opacity: 1 !important;
    position: relative;
    background: #272822;
    color: #fff;
    text-decoration: none;
    text-transform: uppercase;
    border-radius: 10px; /* Радиус скругления углов */

    border: none;
    letter-spacing: 0.1rem;
    font-size: 1rem;
    padding: 1rem 3rem;
    transition: 0.2s;
    margin-bottom: 17px;

}

.buttonConnectGold:hover {
    letter-spacing: 0.2rem;
    padding: 1.1rem 3.1rem;
    background: #39FF14 !important;
    color: #39FF14 !important;
    /* box-shadow: 0 0 35px var(--clr); */
    /*   animation: box 3s infinite; */
}

.buttonConnectGold::before {
    content: "";
    position: absolute;
    inset: 2px;
    background: #272822;
    border-radius: 10px; /* Радиус скругления углов для внутреннего контента */

}

a{
    text-decoration: none!important;
}
.buttonConnectGold span {

    position: relative;
    font-family: Montserrat, sans-serif;
    font-weight: 700;
    line-height: 1;

    z-index: 1;
}








@keyframes move {
    0% {
        transform: translateX(0);
    }
    50% {
        transform: translateX(5px);
    }
    100% {
        transform: translateX(0);
    }
}

@keyframes box {
    0% {
        box-shadow: #27272c;
    }
    50% {
        box-shadow: 0 0 25px #39FF14;
    }
    100% {
        box-shadow: #27272c;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Money_rooms/RoomList.css"],"names":[],"mappings":"AACA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,2JAA2J;IAC3J,sBAAsB;AAC1B;;;AAGA;;IAEI,gCAAgC;;IAEhC,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,SAAS;IACT,eAAe;IACf,cAAc;;IAEd,kBAAkB;AACtB;AACA;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,8BAA8B;IAClC;IACA;QACI,0BAA0B;IAC9B;AACJ;AACA;IACI,UAAU;IACV,4CAA4C;AAChD;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;AACA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,cAAc;IACd,WAAW;AACf;;AAEA,wBAAwB;;AAExB;IACI,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,gCAAgC;AACpC;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,4DAA4D;AAChE;AACA;IACI,6BAA6B;IAC7B,oCAAoC;AACxC;AACA;IACI,UAAU;IACV,YAAY;IACZ,uBAAuB;IACvB,UAAU;IACV,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,uBAAuB;IACvB,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;IACV,6BAA6B;IAC7B,4DAA4D;IAC5D,sBAAsB;AAC1B;AACA;IACI,UAAU;IACV,6BAA6B;AACjC;AACA;IACI,UAAU;IACV,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,eAAe;IACf,gCAAgC;AACpC;AACA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,WAAW;IACX,qBAAqB;IACrB,sBAAsB;IACtB,iBAAiB;IACjB,wBAAwB;IACxB,6DAA6D;AACjE;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,UAAU;IACV,YAAY;IACZ,SAAS;IACT,SAAS;IACT,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,UAAU;IACV,UAAU;IACV,WAAW;IACX,eAAe;IACf,0BAA0B;IAC1B,6DAA6D;IAC7D,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,wBAAwB;IACxB,4DAA4D;IAC5D,sBAAsB;AAC1B;AACA;IACI,iBAAiB;IACjB,UAAU;IACV,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,YAAY;IACZ,UAAU;IACV,QAAQ;AACZ;AACA;IACI,WAAW;IACX,WAAW;IACX,SAAS;IACT,SAAS;AACb;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,kFAAkF;IAClF,gBAAgB;IAChB,0BAA0B;IAC1B,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,iCAAiC,EAAE,4CAA4C;IAC/E,WAAW;IACX,qBAAqB;AACzB;;;AAGA;IACI,gBAAgB;AACpB;AACA;IACI,YAAY;AAChB;AACA;IACI,oCAAoC;AACxC;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;;;;;AAMA;IACI,YAAY;IACZ,oFAAoF;IACpF,gBAAgB;IAChB,0BAA0B;;;IAG1B,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,iCAAiC,EAAE,4CAA4C;IAC/E,WAAW;IACX,qBAAqB;AACzB;AACA;IACI;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;;QAEI,YAAY;IAChB;AACJ;AACA;IACI;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,uBAAuB;QACvB,sBAAsB;QACtB,mBAAmB;IACvB;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;;AAEpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;;IAEI,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,cAAc;;AAElB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;AAEvB;;AAEA;;IAEI,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,aAAa;IACb,uEAAuE;IACvE,0BAA0B;IAC1B,mCAAmC;AACvC;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,aAAa;IACb,uEAAuE;IACvE,0BAA0B;IAC1B,mCAAmC;AACvC;AACA;IACI,6BAA6B;AACjC;AACA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,kCAAkC;IAClC,cAAc;IACd,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,kCAAkC;AACtC;AACA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,4BAA4B;IAChC;AACJ;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB,EAAE,wBAAwB;IACnD,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,gCAAgC;IAChC,oCAAoC;;AAExC;;;AAGA,aAAa;AACb,iCAAiC;AACjC,IAAI;;AAEJ;IACI,iBAAiB;IACjB,kBAAkB;IAClB,6BAA6B;IAC7B,YAAY;IACZ,sBAAsB;;IAEtB,sEAAsE;IACtE,qBAAqB;IACrB,YAAY;IACZ,eAAe;IACf,8BAA8B;AAClC;AACA;IACI,aAAa;IACb,eAAe;AACnB;AACA,sBAAsB;AACtB,0BAA0B;AAC1B,wBAAwB;AACxB,yBAAyB;AACzB,2BAA2B;AAC3B,uBAAuB;AACvB,qCAAqC;AACrC,oBAAoB;AACpB,8BAA8B;AAC9B,oBAAoB;AACpB,oBAAoB;;AAEpB,qEAAqE;AACrE,6BAA6B;AAC7B,oBAAoB;AACpB,uBAAuB;AACvB,sCAAsC;AACtC,2CAA2C;;AAE3C,IAAI;;AAEJ;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,qCAAqC;AACzC;AACA,4BAA4B;AAC5B,6CAA6C;;AAE7C,IAAI;AACJ,0BAA0B;AAC1B,mBAAmB;AACnB,0BAA0B;AAC1B,iBAAiB;AACjB,mBAAmB;AACnB,oBAAoB;AACpB,kBAAkB;AAClB,mBAAmB;AACnB,8EAA8E;AAC9E,6BAA6B;AAC7B,2BAA2B;AAC3B,kBAAkB;AAClB,uBAAuB;AACvB,IAAI;AACJ;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,wCAAwC;AAC5C;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,gDAAgD;IAChD,mBAAmB;AACvB;;;AAGA;;IAEI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mBAAmB,EAAE,mCAAmC;IACxD,gDAAgD;AACpD;;AAEA;IACI,OAAO;IACP,MAAM;IACN,2CAA2C,EAAE,oBAAoB;AACrE;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,2CAA2C,EAAE,oBAAoB;AACrE;AACA;IACI,gBAAgB;IAChB,kBAAkB;;AAEtB;;AAEA;IACI,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI;QACI,mBAAmB;IACvB;IACA;QACI,qBAAqB;IACzB;IACA;QACI,mBAAmB;IACvB;AACJ;AACA,qBAAqB;AACrB,uBAAuB;AACvB,cAAc;AACd,eAAe;AACf,mBAAmB;AACnB,oBAAoB;AACpB,oBAAoB;AACpB,qEAAqE;AACrE,qBAAqB;AACrB,2BAA2B;AAC3B,+BAA+B;AAC/B,sCAAsC;AACtC,IAAI;;AAEJ,WAAW;AACX,qBAAqB;;AAErB,+BAA+B;AAC/B,2BAA2B;AAC3B,wBAAwB;AACxB,qBAAqB;AACrB,0BAA0B;AAC1B,iDAAiD;AACjD,uCAAuC;AACvC,IAAI;AACJ;;IAEI,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;AACA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,4BAA4B;IAChC;IACA;QACI,wBAAwB;IAC5B;AACJ;AACA;IACI,8BAA8B;IAC9B,6BAA6B;IAC7B,8BAA8B;IAC9B,oBAAoB;IACpB,iCAAiC;IACjC,sBAAsB;IACtB,0BAA0B;IAC1B,0BAA0B;IAC1B,2BAA2B;IAC3B,6BAA6B;IAC7B,sBAAsB;AAC1B;AACA;IACI,8BAA8B;IAC9B,8BAA8B;IAC9B,oBAAoB;IACpB,iCAAiC;IACjC,sBAAsB;IACtB,0BAA0B;IAC1B,0BAA0B;;IAE1B,0BAA0B;IAC1B,4BAA4B;IAC5B,qBAAqB;AACzB;AACA;IACI,0BAA0B;AAC9B;AACA;;IAEI,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,aAAa;IACb,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mCAAmC;IACnC,eAAe;IACf,UAAU;IACV,oCAAoC;IACpC,UAAU;;;IAGV,oBAAoB;AACxB;AACA;IACI,SAAS;IACT,SAAS;AACb;AACA;IACI,SAAS;IACT,SAAS;AACb;;;AAGA;IACI,UAAU;AACd;;;AAGA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB,EAAE,4BAA4B;;IAEjD,YAAY;IACZ,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;;AAEvB;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,8BAA8B;IAC9B,yBAAyB;IACzB,qCAAqC;IACrC,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,mBAAmB,EAAE,qDAAqD;;AAE9E;;AAEA;IACI,+BAA+B;AACnC;AACA;;IAEI,kBAAkB;IAClB,mCAAmC;IACnC,gBAAgB;IAChB,cAAc;;IAEd,UAAU;AACd;;;;;;;;;AASA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;IACA;QACI,4BAA4B;IAChC;IACA;QACI,mBAAmB;IACvB;AACJ","sourcesContent":["@import url('https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css');\n@font-face {\n    font-family: 'Oxygen';\n    font-style: normal;\n    font-weight: 400;\n    src: local('Oxygen'), local('Oxygen-Regular'), url(https://fonts.gstatic.com/s/oxygen/v5/LC4u_jU27qpsdszDEgeU_3-_kf6ByYO6CLYdB4HQE-Y.woff2) format('woff2');\n    unicode-range: U+30-39;\n}\n\n\n.content_room_list {\n\n    font-family: Poppins, sans-serif;\n    \n    display: flex;\n    flex-direction: column;\n    opacity: 1;\n    margin: 0;\n    margin-top:50px;\n    overflow: auto;\n\n    min-height: 100svh;\n}\n@keyframes gradient {\n    0% {\n        background-position: 0% 0%;\n    }\n    50% {\n        background-position: 100% 100%;\n    }\n    100% {\n        background-position: 0% 0%;\n    }\n}\n.fade {\n    opacity: 0;\n    animation: fade-in 0.5s ease-in-out forwards;\n}\n\n@keyframes fade-in {\n    from {\n        opacity: 0;\n    }\n    to {\n        opacity: 1;\n    }\n}\n.container-gold-room h2{\n    font-family: Montserrat, sans-serif;\n    font-weight: 900;\n    line-height: 1;\n    color:white;\n}\n\n.search-wrapper.active {}\n\n.search-wrapper .input-holder {\n    height: 70px;\n    width:70px;\n    overflow: hidden;\n    border-radius:6px;\n    position: relative;\n    transition: all 0.3s ease-in-out;\n}\n.search-wrapper.active .input-holder {\n    width:300px;\n    border-radius: 50px;\n    background: #070c1b;\n    transition: all .5s cubic-bezier(0.000, 0.105, 0.035, 1.570);\n}\n.balanceRoom span{\n    color: greenyellow !important;\n    font-family: \"Montserrat\",sans-serif;\n}\n.search-wrapper .input-holder .search-input {\n    width:100%;\n    height: 50px;\n    padding:0px 70px 0 20px;\n    opacity: 0;\n    position: absolute;\n    top:0px;\n    left:0px;\n    background: transparent;\n    box-sizing: border-box;\n    border:none;\n    outline:none;\n    font-family:\"Open Sans\", Arial, Verdana;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 20px;\n    color:#FFF;\n    transform: translate(0, 60px);\n    transition: all .3s cubic-bezier(0.000, 0.105, 0.035, 1.570);\n    transition-delay: 0.3s;\n}\n.search-wrapper.active .input-holder .search-input {\n    opacity: 1;\n    transform: translate(0, 10px);\n}\n.search-wrapper .input-holder .search-icon {\n    width:70px;\n    height:70px;\n    border:none;\n    border-radius:6px;\n    background: #FFF;\n    padding:0px;\n    outline:none;\n    position: relative;\n    z-index: 2;\n    float:right;\n    cursor: pointer;\n    transition: all 0.3s ease-in-out;\n}\n.search-wrapper.active .input-holder .search-icon {\n    width: 50px;\n    height:50px;\n    margin: 10px;\n    border-radius: 30px;\n}\n.search-wrapper .input-holder .search-icon span {\n    width:22px;\n    height:22px;\n    display: inline-block;\n    vertical-align: middle;\n    position:relative;\n    transform: rotate(45deg);\n    transition: all .4s cubic-bezier(0.650, -0.600, 0.240, 1.650);\n}\n.search-wrapper.active .input-holder .search-icon span {\n    transform: rotate(-45deg);\n}\n.search-wrapper .input-holder .search-icon span::before, .search-wrapper .input-holder .search-icon span::after {\n    position: absolute;\n    content:'';\n}\n.search-wrapper .input-holder .search-icon span::before {\n    width: 4px;\n    height: 11px;\n    left: 9px;\n    top: 18px;\n    border-radius: 2px;\n    background: #FE5F55;\n}\n.search-wrapper .input-holder .search-icon span::after {\n    width: 14px;\n    height: 14px;\n    left: 0px;\n    top: 0px;\n    border-radius: 16px;\n    border: 4px solid #FE5F55;\n}\n.search-wrapper .close {\n    position: absolute;\n    z-index: 1;\n    top:24px;\n    right:20px;\n    width:25px;\n    height:25px;\n    cursor: pointer;\n    transform: rotate(-180deg);\n    transition: all .3s cubic-bezier(0.285, -0.450, 0.935, 0.110);\n    transition-delay: 0.2s;\n}\n.search-wrapper.active .close {\n    right:-50px;\n    transform: rotate(45deg);\n    transition: all .6s cubic-bezier(0.000, 0.105, 0.035, 1.570);\n    transition-delay: 0.5s;\n}\n.search-wrapper .close::before, .search-wrapper .close::after {\n    position:absolute;\n    content:'';\n    background: #FE5F55;\n    border-radius: 2px;\n}\n.search-wrapper .close::before {\n    width: 5px;\n    height: 25px;\n    left: 10px;\n    top: 0px;\n}\n.search-wrapper .close::after {\n    width: 25px;\n    height: 5px;\n    left: 0px;\n    top: 10px;\n}\n.pagination button {\n    font-size: 20px;\n    padding: 5px 10px;\n    margin-right: 10px;\n    font-family: \"Oxygen\";\n    background-image: linear-gradient(to right, #7474BF 0%, #348AC7 51%, #7474BF 100%);\n    transition: 0.5s;\n    background-size: 200% auto;\n    color: white;\n    border-radius: 5px;\n}\n\n.pagination button:hover {\n    background-position: right center; /* change the direction of the change here */\n    color: #fff;\n    text-decoration: none;\n}\n\n\n.pagination{\n    margin-top: 15px;\n}\n.pagination .page{\n    margin: 10px;\n}\n.content_table table {\n    transition: opacity 0.5s ease-in-out;\n}\n.sidebar {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 20px;\n}\n\n\n\n\n\n.sidebar button {\n    color: white;\n    background-image: linear-gradient(to right, #24C6DC 0%, #514A9D  51%, #24C6DC  100%);\n    transition: 0.5s;\n    background-size: 200% auto;\n\n\n    border-radius: 50px;\n    margin: 10px;\n    font-size: 20px;\n    background-color: #ba00ff;\n    min-width: 200px;\n}\n.sidebar button:hover {\n    background-position: right center; /* change the direction of the change here */\n    color: #fff;\n    text-decoration: none;\n}\n@media screen and (max-width: 519px) {\n    .content_table table {\n        max-width: 1000px;\n        font-size: 12px;\n    }\n\n    th,\n    td {\n        padding: 8px;\n    }\n}\n@media  screen and (max-width: 380px){\n    .content_table h1{\n        font-size: 25px;\n    }\n}\n@media screen and (max-width: 673px) {\n    .sidebar {\n        justify-content: center;\n        flex-direction: column;\n        align-items: center;\n    }\n}\n\n.search_box {\n    display: flex;\n    justify-content: center;\n    margin-top: 10px;\n\n}\n.search_box.room{\n    margin-bottom: 10px;\n}\n.second_list{\n    display: flex;\n    justify-content: center;\n}\n.second_list .ico{\n\n    margin-left: 20px;\n    margin-top: 35px;\n}\n.fa-refresh{\n    font-size: 30px;\n    color: #24C6DC;\n\n}\n\n.input-holder{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.container-gold-room{\n    max-height:150px;\n    display: flex;\n    justify-content: center;\n    margin-bottom: 20px;\n\n}\n\n.content-gold-room{\n\n    border-radius: 15px;\n    display: flex;\n    justify-content: center;\n    padding: 10px;\n    background: linear-gradient(-45deg, #FFD700, #FFA500, #FFD700, #FFA500);\n    background-size: 200% 200%;\n    animation: shine 2s linear infinite;\n}\n.content-bonus-room{\n    width: 257px;\n    border-radius: 15px;\n    display: flex;\n    justify-content: center;\n    padding: 10px;\n    background: linear-gradient(-45deg, #4CAF50, #2E8B57, #4CAF50, #2E8B57);\n    background-size: 200% 200%;\n    animation: shine 2s linear infinite;\n}\n.content-gold-room h2{\n    text-align: center !important;\n}\n.content-gold-room p{\n    text-align: center !important;\n    font-weight: 700;\n    font-family: 'Poppins', sans-serif;\n    color: #4f830b;\n    font-size: 40px;\n}\n.spans p{\n    text-align: center;\n    font-family: Montserrat,sans-serif;\n}\n@keyframes shine {\n    0% {\n        background-position: 200% 0;\n    }\n    100% {\n        background-position: -200% 0;\n    }\n}\n.content_table {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.content_table table {\n    border-collapse: collapse;\n    border-radius: 10px;\n    max-width: 1000px;\n    background-color: #161c32; /* Темный цвет таблицы */\n    color: #FFF;\n    font-family: Arial, sans-serif;\n}\n\n.content_table th, td {\n    padding: 16px;\n    text-align: center;\n    border-bottom: 1px solid #2C3845;\n    font-family: \"Montserrat\",sans-serif;\n\n}\n\n\n/*tr:hover {*/\n/*    background-color: #574F7D;*/\n/*}*/\n\n.buttonConnect {\n    padding: 5px 10px;\n    border-radius: 5px;\n    /*background-color: #46bebd;*/\n    color: white;\n    box-sizing: border-box;\n\n    background: linear-gradient(90deg, #03a9f4, #f441a5, #ffeb3b, #03a9f4);\n    background-size: 400%;\n    border: none;\n    cursor: pointer;\n    font-family: Arial, sans-serif;\n}\n.info-gold-i{\n    color:#5C62EC;\n    font-size: 30px;\n}\n/*.buttonConnectGold{*/\n/*    text-align: center;*/\n/*    margin-top: 10px;*/\n/*    padding: 5px 10px;*/\n/*    border-radius: 10px;*/\n/*    font-size: 20px;*/\n/*    !*background-color: #46bebd;*!*/\n/*    color: white;*/\n/*    box-sizing: border-box;*/\n/*    height: 50px;*/\n/*    width: 200px;*/\n\n/*    background: linear-gradient(90deg, #03a9f4, #f441a5, #03a9f4);*/\n/*    background-size: 400%;*/\n/*    border: none;*/\n/*    cursor: pointer;*/\n/*    font-family: Arial, sans-serif;*/\n/*    animation: shine 8s linear infinite;*/\n\n/*}*/\n\n@keyframes animate {\n    0% {\n        background-position: 0%;\n    }\n    100% {\n        background-position: 400%;\n    }\n}\n\n.buttonConnect:hover {\n    animation: animate 8s linear infinite;\n}\n/*.buttonConnectGold:hover{*/\n/*    animation: animate 8s linear infinite;*/\n\n/*}*/\n/*.buttonConnect:before {*/\n/*    content: \"\";*/\n/*    position: absolute;*/\n/*    top: -5px;*/\n/*    right: -5px;*/\n/*    bottom: -5px;*/\n/*    left: -5px;*/\n/*    z-index: -1;*/\n/*    background: linear-gradient(90deg, #03a9f4, #f441a5, #ffeb3b, #03a9f4);*/\n/*    background-size: 400%;*/\n/*    border-radius: 40px;*/\n/*    opacity: 0;*/\n/*    transition: .5s;*/\n/*}*/\n.pulse-circle {\n    display: inline-block;\n    width: 12px;\n    height: 12px;\n    margin-left: 6px;\n    border-radius: 50%;\n    background-color: #4CAF50;\n    animation: pulse 2s ease-in-out infinite;\n}\n.box-gold-room form {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    width: 500px;\n    padding: 50px 35px;\n    box-sizing: border-box;\n    background: linear-gradient(0deg, #000, #272727);\n    border-radius: 10px;\n}\n\n\n.box-gold-room form::before,\n.box-gold-room form::after {\n    content: '';\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    border-radius: 10px; /* Скругляем края псевдоэлементов */\n    background: linear-gradient(0deg, #000, #272727);\n}\n\n.box-gold-room form::before {\n    left: 0;\n    top: 0;\n    box-shadow: 0 0 30px rgba(255, 215, 0, 0.9); /* Золотистая тень */\n}\n\n.box-gold-room form::after {\n    right: 0;\n    bottom: 0;\n    box-shadow: 0 0 30px rgba(255, 215, 0, 0.9); /* Золотистая тень */\n}\n.box-gold-room form p{\n    font-weight: 700;\n    text-align: center;\n\n}\n\n.pulse-circle.red{\n    background-color: red;\n}\n.pagination{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n@keyframes pulse {\n    0% {\n        transform: scale(1);\n    }\n    50% {\n        transform: scale(1.2);\n    }\n    100% {\n        transform: scale(1);\n    }\n}\n/*.modal-container {*/\n/*    position: fixed;*/\n/*    top: 0;*/\n/*    left: 0;*/\n/*    width: 100%;*/\n/*    height: 100%;*/\n/*    z-index: 100;*/\n/*    background: rgba(0, 0, 0, 0.5); !* Приглушение заднего фона *!*/\n/*    display: flex;*/\n/*    align-items: center;*/\n/*    justify-content: center;*/\n/*    animation: fadeIn 0.3s ease-in;*/\n/*}*/\n\n/*.modal {*/\n/*    display: flex;*/\n\n/*    justify-content: center;*/\n/*    align-items: center;*/\n/*    background: #fff;*/\n/*    padding: 20px;*/\n/*    border-radius: 5px;*/\n/*    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);*/\n/*    animation: slideIn 0.3s ease-in;*/\n/*}*/\n.modal-container{\n\n    z-index: 100;\n    opacity: 1!important;\n    /*height: 100vh;*/\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n    to {\n        opacity: 1;\n    }\n}\n\n@keyframes slideIn {\n    from {\n        transform: translateX(-50px);\n    }\n    to {\n        transform: translateX(0);\n    }\n}\n.real-cash-button {\n    background: #8BC34A !important;\n    margin-right: 10px !important;\n    border-radius: 12px !important;\n    border: 0 !important;\n    box-sizing: border-box !important;\n    color: #eee !important;\n    cursor: pointer !important;\n    font-size: 15px !important;\n    margin-top: 38px !important;\n    text-align: center !important;\n    width: 100% !important;\n}\n.bonus-cash-button{\n    background: #5C62EC !important;\n    border-radius: 12px !important;\n    border: 0 !important;\n    box-sizing: border-box !important;\n    color: #eee !important;\n    cursor: pointer !important;\n    font-size: 15px !important;\n\n    margin-top: 38px!important;\n    text-align: center!important;\n    width: 100%!important;\n}\n.enter_model_h2{\n    margin-bottom: 0!important;\n}\n.tooltip-container {\n\n    position: relative;\n    display: inline-block;\n    cursor: pointer;\n    padding: 10px;\n    z-index:100;\n}\n\n.tooltip-text {\n    position: absolute;\n    background-color: black;\n    color: #fff;\n    padding: 8px;\n    border-radius: 15px;\n    font-family: monospace , sans-serif;\n    font-size: 16px;\n    opacity: 0;\n    transition: opacity 0.3s ease-in-out;\n    top: -300%;\n\n\n    pointer-events: none;\n}\n.tooltip-text.gold{\n    top:-260%;\n    left:-10%;\n}\n.tooltip-text.bonus{\n    top:-320%;\n    left:-20%;\n}\n\n\n.tooltip-container:hover .tooltip-text {\n    opacity: 1;\n}\n\n\n.buttonConnectGold {\n    text-decoration: none;\n    opacity: 1 !important;\n    position: relative;\n    background: #272822;\n    color: #fff;\n    text-decoration: none;\n    text-transform: uppercase;\n    border-radius: 10px; /* Радиус скругления углов */\n\n    border: none;\n    letter-spacing: 0.1rem;\n    font-size: 1rem;\n    padding: 1rem 3rem;\n    transition: 0.2s;\n    margin-bottom: 17px;\n\n}\n\n.buttonConnectGold:hover {\n    letter-spacing: 0.2rem;\n    padding: 1.1rem 3.1rem;\n    background: #39FF14 !important;\n    color: #39FF14 !important;\n    /* box-shadow: 0 0 35px var(--clr); */\n    /*   animation: box 3s infinite; */\n}\n\n.buttonConnectGold::before {\n    content: \"\";\n    position: absolute;\n    inset: 2px;\n    background: #272822;\n    border-radius: 10px; /* Радиус скругления углов для внутреннего контента */\n\n}\n\na{\n    text-decoration: none!important;\n}\n.buttonConnectGold span {\n\n    position: relative;\n    font-family: Montserrat, sans-serif;\n    font-weight: 700;\n    line-height: 1;\n\n    z-index: 1;\n}\n\n\n\n\n\n\n\n\n@keyframes move {\n    0% {\n        transform: translateX(0);\n    }\n    50% {\n        transform: translateX(5px);\n    }\n    100% {\n        transform: translateX(0);\n    }\n}\n\n@keyframes box {\n    0% {\n        box-shadow: #27272c;\n    }\n    50% {\n        box-shadow: 0 0 25px #39FF14;\n    }\n    100% {\n        box-shadow: #27272c;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
